export default "__VITE_ASSET__108c1647__"